<div class="page-wrapper">
  <h1 class="mat-h1"
      style="text-align: center;"> {{T.PM.TITLE|translate}}</h1>
  <metric></metric>
</div>
